// extracted by mini-css-extract-plugin
export default {"wrapper":"DescriptionCard_wrapper__oRRTV"};